import { render, staticRenderFns } from "./WritingIndex.vue?vue&type=template&id=0c300463&"
import script from "./WritingIndex.vue?vue&type=script&lang=js&"
export * from "./WritingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports